export interface TimelineFeatures {
    helpMeNowQuestion: string;
    isChatExpertAssistAutoCompleteEnabled: boolean;
    isChatProactiveSuggestionsEnabled: boolean;
    isGuidedFlowRecommendationEnabled: boolean;
    isHelpMeNowEnabled: boolean;
    isOzmoIFrameEnabled: boolean;
    isProactiveGuidanceEnabled: boolean;
    isSimplrWebsocketLiveEnabled: boolean;
    /** @deprecated Used for legacy proactive features. */
    isProactiveEnabled: boolean;
    isSalesFAQEnabled: boolean;
    isGroundedSearchExperimentEnabled: boolean;
    proactiveSuggestionInterval: number;
}

export const defaultHelpMeNowQuestion = "Help the customer with their technical problem";
export const defaultProactiveSuggestionInterval = 60000;

export interface WorkspaceFeatures {
    // Note: Some flags use name mapping (see FLAG_NAME_MAP in ./defaults.ts, used in ./useFlags.tsx)
    customFlowSystemId?: string;
    includesSendToPartnerMeta: boolean;
    isAiAssistGuidedFlowEnabled: boolean;
    isAutoSummaryEnabled: boolean;
    isChallengeEnabled: boolean; // Maps to "Sales-isChallengeEnabled"
    isChatIssueSummaryEnabled: boolean;
    isDeviceActivationGuideIntentAutoOpenEnabled: boolean;
    isGaiaMultiStepSummaryEnabled: boolean; // Maps to "isGaiaMultiStepSummaryEnabled"
    isGuidedFlowRecommendationEnabled: boolean;
    isPreviousSessionSummaryEnabled: boolean;
    /** @deprecated Used for legacy proactive features. */
    isProactiveEnabled: boolean;
    isRapportEnabled: boolean;
    isChecklistSummaryEnabled: boolean;
    isVerizonCareEnabled: boolean;
    isLightModeEnabled?: boolean;
    isGaiaCallResolutionEnabled: boolean;
    isMicroLearningV2Enabled: boolean;
    logoutPendingDuration: number;
    isTrainingFeedbackEnabled: boolean;
    isUpdatedEndSessionFlowEnabled: boolean;
    sendSummaryFromBackend: boolean;
    useMdnForAccountNo: boolean;
    isPacingEnabled: boolean;
    isGlowBarPacingEnabled: boolean;
    isUsingMovedDiscoveryAndEngagementQuestions: boolean; // Maps to "Sales-isUsingMovedDiscoveryAndEngagementQuestions"
    isUpdatedCustomerHandoffEnabled: boolean;
    isGuidedBrowsingEnabled: boolean; // Maps to "Sales-isGuidedBrowsingEnabled"
    isLongFormAiEnabled: boolean; // Maps to "Sales-isLongFormAiEnabled"
    isAudioDisclosuresEnabled: boolean; // Maps to "Sales-isAudioDisclosuresEnabled"
    isVoiceWorkspaceRedesignV2Enabled: boolean; // Maps to "EWP-isVoiceWorkspaceRedesignV2Enabled"
    isStringExamplesListEnabled: boolean; // Maps to "Sales-isStringExamplesListEnabled"
    isSolveGuidedFlowsEnabled: boolean;
    isExpertHubScheduleEnabled: boolean;
    isExpertHubAutoAvailableEnabled: boolean;
    dynamicCallbackSessionSummaryEnabled: boolean;
    dynamicCallbackCallbarEnabled: boolean;
    callbackLimit: number;
    isClaimDetailsEnabled: boolean;
}

export type TimelineContextType = Record<keyof TimelineFeatures, boolean | number | string>;
export type WorkspaceContextType = Record<keyof WorkspaceFeatures, boolean | number | string | undefined>;

// group name used for analytics
export type Group = "Timeline" | "Workspace";
